<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.student.studentApplicationImport')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">
                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{ alertMessage }}</b-alert>

                <!-- Filters -->
                <div class="card">
                    <div class="card-header bg-light">
                        <h3 class="card-title">{{ $t('form.student.studentApplicationImport') }}</h3>

                        <button type="submit" class="btn btn-primary float-right"
                            @click="acceptStudentFile">{{ $t('form.student.import') }}</button>

                        <button type="submit" class="btn btn-danger float-right mr-3"
                            @click="rejectStudentFile">{{ $t('button.cancel') }}</button>
                    </div>

                    <div class="card-body">
                        <!-- table  -->
                        <div class="card-body table-responsive p-0">
                            <table class="table table-hover">
                                <thead>
                                    <tr class="header">
                                        <th>{{ $t('form.student.studentNumber') }}</th>
                                        <th>{{ $t('form.student.error') }}</th>
                                        <th>{{ $t('form.student.documentType') }}</th>
                                        <th>{{ $t('form.student.documentFileName') }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="student in students" :key="student.id">
                                        <td :class="{'text-danger': student.not_found}">{{ student.id }}</td>
                                        <td v-if="student.not_found" class="text-danger">Student number not found</td>
                                        <td v-else></td>
                                        <td colspan="3">
                                            <table class="table table-hover">
                                                <tbody>
                                                    <tr v-for="(document, index) in student.documents" :key="index">
                                                        <td>{{ document.type }}</td>
                                                        <td>{{ document.file }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- table end  -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['permissions', 'user', 'dateFormat'],

    data() {
        return {
            students: [],
            alert: false,
            alertClass: '',
            alertMessage: '',
            isLoading: false,
            fullPage: true,
        };
    },

    mounted() {
        if (!this.permissions.createImportApplications) {
            return this.$router.push('/');
        }

        this.setStudentData();
    },

    methods: {
        setStudentData() {
            const studentsData = JSON.parse(localStorage.getItem('students'));
            if (studentsData && studentsData.length > 0) {
                this.students = studentsData;
            } else {
                this.showAlert("No student data found.", "warning");
            }
        },

        rejectStudentFile() {
            this.$router.push('/application-documents-import');
        },

        acceptStudentFile() {
            this.isLoading = true;
            axios.post('/api/students/save-application-documents', { students: this.students })
                .then(response => {
                    this.isLoading = false;
                    this.showAlert("Files imported successfully!", "success");
                    this.$router.push('/application-documents-import');
                })
                .catch(error => {
                    this.showAlert(error.response.data.message, "danger");
                    this.isLoading = false;
                });
        },

        showAlert(msg, cls = 'success') {
            this.alertMessage = msg;
            this.alertClass = cls;
            this.alert = true;
        }
    }
};
</script>

<style scoped>
.table-bordered {
    border: 1px solid #dee2e6;
}

.table-bordered td {
    border: 1px solid #dee2e6;
}
</style>